module.exports = __webpack_public_path__ + "assets/images/slope-condos/mobile.svg?v=7f2905ae";